import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import axios from 'axios';
import App from './routes/App';
import * as Sentry from '@sentry/browser';
import { IntercomProvider } from 'react-use-intercom';
import { ConfigProvider } from 'antd';
import IntercomControlProvider from './contexts/IntercomContext';
import { message } from 'antd';
import 'antd/dist/reset.css';

if (process.env.NODE_ENV && process.env.NODE_ENV === 'production') {
  // error tracking
  Sentry.init({
    dsn: 'https://de76d30cda4c4bde84e56d1effe0643d@sentry.io/1329457',
  });
}

const targetElement = document.getElementById('root');
const INTERCOM_APP_ID = 'ew7am633';

class AuthWrapper extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return <App />;
  }
}

axios.interceptors.response.use(
  async (response) => {
    // Check if skipInterceptor option is true, then skip the logic
    if (response.config.skipInterceptor) {
      return response;
    }
    if (response.data.status === 'unauthorized') {
      const currentUrl = window.location.toString();
      if (currentUrl.includes('/error-404')) {
        return response;
      }
      if (!currentUrl.includes('/login')) {
        return (window.location = '/login');
      }
    } else if (response.data.subscription === 'inactive-apphub-subscripton') {
      return (window.location = `/dashboard/connect/apphub/signin?subscriptionPending=true&origin_app=${response.data.originApp}`);
    } else if (response.data.subscription === 'inactive-shopify') {
      // ADDING: redirect to "select a plan page"
      return (window.location = '/dashboard/connect/plan');
    } else if (response.data.subscription === 'paused') {
      return (window.location = '/dashboard/account/profile');
    } else {
      return response;
    }
  },
  (error) => {
    if (error.response && error.response.status === 429) {
      const RATE_LIMIT_KEY = 'rate_limit_error';
      message.error({
        content: "Slow down a bit, you're moving too fast!",
        key: RATE_LIMIT_KEY,
        duration: 3,
      });
    }
    return Promise.reject(error);
  },
);
const isDashboard = window.location.pathname.includes('/dashboard');
const root = ReactDOM.createRoot(document.getElementById('root'));
const theme = {
  token: {
    colorPrimary: '#67C2C2', // Custom primary color
    colorInfo: '#67C2C2',
  },
};

root.render(
  <BrowserRouter>
    <ConfigProvider theme={theme}>
      <IntercomProvider appId={INTERCOM_APP_ID}>
        <IntercomControlProvider isEnabled={isDashboard}>
          <AuthWrapper />
        </IntercomControlProvider>
      </IntercomProvider>
    </ConfigProvider>
  </BrowserRouter>,
);

if (module.hot) {
  module.hot.accept();
}
